import { Attachment } from "../../../shared-components/models/attachment.model";

export class AbsentNotice {
    Id: number;
    StudentId: number;
    SubmittedPeopleId: number;
    SubmittedName: string;
    StudentNumber: string;
    FirstName: string;
    MiddleName: string;
    LastName: string;
    NickName: string;
    Deleted: boolean;
    StartDate: Date;
    EndDate: Date;
    Reason: string;
    Status: string;
    LastUpdated: Date;
    LastUpdatedBy: number;
    Attachment: boolean;
    Attachments: Attachment[] = [];
}